import * as React from 'react'
import {CoordinateSystem} from '../../enums/CoordinateSystem'
import {nls} from '../nls'

interface Props {
  selected: CoordinateSystem
  onChange: (change: CoordinateSystem) => void
  className: string
}

export class CsSelector extends React.Component<Props> {
  render() {
    return (
      <select
        className={this.props.className}
        value={this.props.selected}
        onChange={e => {
          this.props.onChange(e.target.value as CoordinateSystem)
        }}
      >
        <option value={CoordinateSystem.BG2005CAD}>{nls.transformations.BG2005CAD}</option>
        <option value={CoordinateSystem.BGS2005}>{nls.transformations.BGS2005}</option>
        <option value={CoordinateSystem.GEOGRAPHIC}>{nls.transformations.GEOGRAPHIC}</option>
        <option value={CoordinateSystem.WEB_MERCATOR}>{nls.transformations.WEB_MERCATOR}</option>
        <option value={CoordinateSystem.UTM34}>{nls.transformations.UTM34}</option>
        <option value={CoordinateSystem.UTM35}>{nls.transformations.UTM35}</option>
        <option value={CoordinateSystem.BG_703}>{nls.transformations.BG_703}</option>
        <option value={CoordinateSystem.BG_705}>{nls.transformations.BG_705}</option>
        <option value={CoordinateSystem.BG_707}>{nls.transformations.BG_707}</option>
        <option value={CoordinateSystem.BG_709}>{nls.transformations.BG_709}</option>
        <option value={CoordinateSystem.BG_3024}>{nls.transformations.BG_3024}</option>
        <option value={CoordinateSystem.BG_3027}>{nls.transformations.BG_3027}</option>
        <option value={CoordinateSystem.BG50324}>{nls.transformations.BG50324}</option>
        <option value={CoordinateSystem.BG50327}>{nls.transformations.BG50327}</option>
        <option value={CoordinateSystem.BG50621}>{nls.transformations.BG50621}</option>
        <option value={CoordinateSystem.BG50627}>{nls.transformations.BG50627}</option>
      </select>
    )
  }
}

export class CsSelectorLite extends React.Component<Props> {
  render() {
    return (
      <select
        className={this.props.className}
        value={this.props.selected}
        onChange={e => {
          this.props.onChange(e.target.value as CoordinateSystem)
        }}
      >
        <option value={CoordinateSystem.BG2005CAD}>{nls.transformations.BG2005CAD}</option>
        <option value={CoordinateSystem.WEB_MERCATOR}>{nls.transformations.WEB_MERCATOR}</option>
        <option value={CoordinateSystem.GEOGRAPHIC}>{nls.transformations.GEOGRAPHIC}</option>
        <option value={CoordinateSystem.BG_703}>{nls.transformations.BG_703}</option>
        <option value={CoordinateSystem.BG_705}>{nls.transformations.BG_705}</option>
        <option value={CoordinateSystem.BG_707}>{nls.transformations.BG_707}</option>
        <option value={CoordinateSystem.BG_709}>{nls.transformations.BG_709}</option>
        <option value={CoordinateSystem.UTM34}>{nls.transformations.UTM34}</option>
        <option value={CoordinateSystem.UTM35}>{nls.transformations.UTM35}</option>
        <option value={CoordinateSystem.BG50324}>{nls.transformations.BG50324}</option>
        <option value={CoordinateSystem.BG50327}>{nls.transformations.BG50327}</option>
        <option value={CoordinateSystem.BG50621}>{nls.transformations.BG50621}</option>
        <option value={CoordinateSystem.BG50627}>{nls.transformations.BG50627}</option>
        <option value={CoordinateSystem.BG_3024}>{nls.transformations.BG_3024}</option>
        <option value={CoordinateSystem.BG_3027}>{nls.transformations.BG_3027}</option>
      </select>
    )
  }
}
